export default function ListePrixSpas(){
    return (
        <div className="container">
            <h3>Liste prix spas</h3>
        </div>
    )
}